import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '../button';
import { Trans, useTranslation } from 'react-i18next';
import { useExitImpersonateUser } from '@services/resources/users/impersonate/exit';
import { useAppContext } from '@contexts/app';
import { snakeToCamelCase } from '@utils/textHelpers';
import { localStore } from '@utils/localStore';
import { useEffect } from 'react';

export const ImpersonateBanner = () => {
  const { firstName, lastName, tenant, roles, isLogged, admin } = useAppContext();

  const { t } = useTranslation('app');

  const active = isLogged && admin.isLogged;
  const href = localStore.getItem('app-href') as string;

  const { mutate } = useExitImpersonateUser({
    callback: () => {
      // eslint-disable-next-line immutable/no-mutation
      window.location.href = href;
    },
  });

  useEffect(() => {
    if (!active) return;
    localStore.removeItem('app-start-impersonate');
  }, [active]);

  if (!active) return null;

  return (
    <div className="header-banner bg-blue-300">
      <div className="mx-auto w-full flex items-center justify-between px-4 py-1">
        <span className="flex h-14 items-center gap-5 text-sm text-white">
          <SvgConsumer className="shrink-0 text-heading-xs" id="impersonate" />
          <span>
            <Trans
              t={t}
              i18nKey="navigation.impersonate.title"
              values={{
                company: tenant.companyName,
                user: [firstName, lastName].join(' '),
                role:
                  roles.length > 0
                    ? roles
                        .filter((role) => !role.discardedAt)
                        .map((role) =>
                          t(['role', snakeToCamelCase(String(role.name || ''))].join('.')),
                        )
                        .join(', ')
                    : '',
              }}
              components={{ bold: <strong /> }}
            />
          </span>
        </span>
        <Button onClick={() => mutate()} size="sm" variant="secondary">
          <SvgConsumer className="shrink-0" id="signIn" />
          <span>{t('navigation.impersonate.action')}</span>
        </Button>
      </div>
    </div>
  );
};
